import React, { useRef, useState } from 'react'
import { Button, TextField } from '@adobe/react-spectrum'
import { applyLicense, findLicense, findUser } from '../api/database-api'
import BackButton from '../components/BackButton'

export default function Ghost() {
  const [loading, setLoading] = useState()
  const [foundUser, setFoundUser] = useState()
  const emailRef = useRef()
  const licenseRef = useRef()

  const onSearchClicked = async () => {
    const email = emailRef.current.getInputElement().value
    if (!email) {
      window.alert("Email can't be empty.")
      return
    }
    setLoading(true)
    try {
      const user = await findUser(email)
      licenseRef.current.getInputElement().value = user.license
      setFoundUser(user)
    } catch (error) {
      window.alert("User with given email doesn't exist.")
      console.error(error)
    }
    setLoading(false)
  }

  const onApplyClicked = async () => {
    const license = licenseRef.current.getInputElement().value
    if (!license) {
      window.alert("License can't be empty.")
      return
    }
    setLoading(true)
    try {
      await findLicense(license)
      await applyLicense(license)
      emailRef.current.getInputElement().value = ''
      licenseRef.current.getInputElement().value = ''
      window.alert('License updated successfully.')
    } catch (error) {
      window.alert("License with given ID doesn't exist.")
      console.error(error)
    }
    setLoading(false)
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        padding: 16,
        maxWidth: 400,
      }}
    >
      <BackButton />
      <span>Enter user's email to search for it in database.</span>
      <TextField ref={emailRef} label="Email:" />
      <Button
        onPress={onSearchClicked}
        variant="cta"
        marginTop="size-200"
        marginBottom="size-200"
        isDisabled={loading}
      >
        Search
      </Button>

      {foundUser && (
        <span style={{ margin: '8px 0 16px 0' }}>
          Found user with license:{' '}
          <strong style={{ color: 'green' }}>{foundUser.license}</strong>
          <br />
          Now, click button <strong>"Apply ID"</strong> below.
        </span>
      )}

      <span>Or, enter user's license ID directly.</span>
      <TextField ref={licenseRef} label="License:" />
      <Button
        variant="cta"
        marginTop="size-200"
        marginBottom="size-300"
        isDisabled={loading}
        onPress={onApplyClicked}
      >
        Apply ID
      </Button>
      <span>
        * To login to user's account go to:{' '}
        <a
          href="https://app.konectsocial.com/"
          rel="noopener noreferrer"
          target="_blank"
        >
          https://app.konectsocial.com/
        </a>{' '}
        and login with <strong>notifications@konectsocial.com</strong> account.
      </span>
    </div>
  )
}
